import {
    AppBar,
    Button,
    Icon,
    IconButton,
    Stack,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import usePageSize from "../../hooks/UsePageSize";
import { getAppBarItemsForSize } from "../../utils/menu";
import AppBarMenuItem from "./AppBarMenuItem";
import UserMenu from "./UserMenu";

export default function CustomizedAppBar(props: { toggleDrawer: () => void }) {
    const size = usePageSize();
    const appBarItems = getAppBarItemsForSize(size);

    const theme = useTheme();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <AppBar position="fixed">
            <Toolbar>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    width="100%"
                >
                    {isSmallScreen && (
                        <>
                            <IconButton onClick={props.toggleDrawer}>
                                <Icon fontSize="large">menu</Icon>
                            </IconButton>

                            <Typography>
                                <a
                                    href={process.env.REACT_APP_HOME_URL}
                                    style={{
                                        textDecoration: "none",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    پرشین سازه
                                </a>
                            </Typography>
                            {/*</a>*/}
                        </>
                    )}

                    {!isSmallScreen && (
                        <a
                            href={process.env.REACT_APP_HOME_URL}
                            style={{ height: "40px", width: "40px" }}
                        >
                            <img
                                width={40}
                                height={40}
                                src={
                                    theme.palette.mode === "dark"
                                        ? "./images/logo_dark.png"
                                        : "./images/logo_light.png"
                                }
                            />
                        </a>
                    )}

                    <Stack
                        direction="row"
                        spacing={2}
                        flexGrow={1}
                        sx={{ pl: 2 }}
                    >
                        {appBarItems.map((page) => (
                            <AppBarMenuItem
                                key={page.url}
                                menuItem={page}
                            />
                        ))}
                    </Stack>
                    <Link to="/subscriptions">
                        <Button
                            sx={{
                                display: { md: "inline-block", xs: "none" },
                            }}
                            size="small"
                            variant="contained"
                            color="secondary"
                        >
                            مقایسه اشتراک ها
                        </Button>
                    </Link>

                    <UserMenu />
                </Stack>
            </Toolbar>
        </AppBar>
    );
}
